// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"dfa636fc","57":"dfa636fc","230":"260799ff","434":"dfa636fc","550":"dfa636fc","705":"dfa636fc","986":"dfa636fc"}[chunkId] + ".chunk.css";
};